import React from 'react'
import ReactModal from 'react-modal'

const EventEvalModal = ({ handleCloseEventEvalModal, eventName, eventEvalUrl }) => {

  return(
    <div>
      <ReactModal
        className={'react-modal closing-details generic info-modal info-pop-up'}
        onRequestClose={handleCloseEventEvalModal}
        isOpen
        appElement={document.querySelector('#root')}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        style={{ overlay: { background: 'rgba(60,59,59,0.75)' }}}>
        <div className='generic-info-modal-header'>
          <i className='fa fa-times-thin fa-2x' onClick={handleCloseEventEvalModal}></i>
        </div>
        <div className='generic-info-modal-content'>
          <h4>Thank You</h4>
          <div className='thank-you-body-content'>
            <h6>Thank you for participating in the {eventName}.</h6>
            <br />
            { eventEvalUrl ?
              <div>
                <h6>Feedback</h6>
                <p>If you haven’t already, please provide your feedback on each session you participated in by clicking the ‘Give Feedback’ button on each session block.</p>
                <p>Additionally, please take this brief survey to rate your overall experience and help us to continuously improve our virtual offerings.</p>
                <a className='take-event-eval' href={eventEvalUrl} target='_blank' rel='noopener noreferrer'>
                  Take Survey &nbsp;<i className='fa fa-angle-right'></i>
                </a>
                <hr/>
              </div>
              : '' }
            <div className='button-container'>
              <div>
                <button
                  className='btn btn-danger-tertiary close-modal'
                  onClick={handleCloseEventEvalModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  )

}

export default EventEvalModal